import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const billingService = {
  checkProfile,
  getOptions,
  getProfile,
  getProfiles,
  saveProfile,
  createProfile,
  updateProfile,
  deleteProfile,
  getProvinces,
  getInvoices,
  getInvoice,
  createInvoice,
  updateInvoice,
  issueInvoice,
  markAsPaid,
  cancelInvoice,
  deleteInvoice,
  getSubmissionList,
  sendToSDI,
  refreshSDIStatus,
  sendToTS,
  refreshTSStatus,
  sendInvoiceToSDI,
  refreshInvoiceSDIStatus,
  sendInvoiceToTS,
  refreshInvoiceTSStatus,
  downloadPDF,
  downloadXML,
  downloadInvoiceXML,
  getByAnnotation,
  downloadPDFByAnnotation,
  downloadXMLByAnnotation,
};

function checkProfile() {
  var sett = { headers: authHeader() };
  return axios
    .get("billing/check-profile", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getOptions() {
  var sett = { headers: authHeader() };
  return axios
    .get("billing/options", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getProfiles(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("billing/profiles", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getProfile(filters = {}) {
  return getProfiles(filters);
}

function saveProfile(data) {
  return createProfile(data);
}

function createProfile(data) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/profiles", data, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function updateProfile(hash, data) {
  var sett = { headers: authHeader() };
  return axios
    .put("billing/profiles/" + hash, data, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function deleteProfile(hash) {
  var sett = { headers: authHeader() };
  return axios
    .delete("billing/profiles/" + hash, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getProvinces(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("utilities/province", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getInvoices(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("billing/invoices", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getInvoice(hash) {
  var sett = { headers: authHeader() };
  return axios
    .get("billing/invoices/" + hash, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function createInvoice(data) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices", data, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function updateInvoice(hash, data) {
  var sett = { headers: authHeader() };
  return axios
    .put("billing/invoices/" + hash, data, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function issueInvoice(hash, data = {}) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices/" + hash + "/issue", data, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function markAsPaid(hash, data) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices/" + hash + "/mark-paid", data, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function cancelInvoice(hash) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices/" + hash + "/cancel", {}, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function deleteInvoice(hash) {
  var sett = { headers: authHeader() };
  return axios
    .delete("billing/invoices/" + hash, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getSubmissionList(filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("billing/invoices/submission-list", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function sendToSDI(hash) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices/" + hash + "/send-sdi", {}, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function refreshSDIStatus(hash) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices/" + hash + "/refresh-sdi-status", {}, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function sendToTS(hash) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices/" + hash + "/send-ts", {}, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function refreshTSStatus(hash) {
  var sett = { headers: authHeader() };
  return axios
    .post("billing/invoices/" + hash + "/refresh-ts-status", {}, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function sendInvoiceToSDI(hash) {
  return sendToSDI(hash);
}

function refreshInvoiceSDIStatus(hash) {
  return refreshSDIStatus(hash);
}

function sendInvoiceToTS(hash) {
  return sendToTS(hash);
}

function refreshInvoiceTSStatus(hash) {
  return refreshTSStatus(hash);
}

function downloadPDF(hash) {
  var sett = { headers: authHeader(), responseType: "blob" };
  return axios
    .get("billing/invoices/" + hash + "/download-pdf", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function downloadXML(hash) {
  var sett = { headers: authHeader(), responseType: "blob" };
  return axios
    .get("billing/invoices/" + hash + "/download-xml", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function downloadInvoiceXML(hash) {
  return downloadXML(hash);
}

function getByAnnotation(annotationId, filters = {}) {
  var sett = { headers: authHeader(), params: filters };
  return axios
    .get("billing/invoices/by-annotation/" + annotationId, sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function downloadPDFByAnnotation(annotationId, filters = {}) {
  var sett = { headers: authHeader(), params: filters, responseType: "blob" };
  return axios
    .get("billing/invoices/by-annotation/" + annotationId + "/download-pdf", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function downloadXMLByAnnotation(annotationId, filters = {}) {
  var sett = { headers: authHeader(), params: filters, responseType: "blob" };
  return axios
    .get("billing/invoices/by-annotation/" + annotationId + "/download-xml", sett)
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}
